var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "room-list",
    class: {
      'media-auto': _vm.mediaAuto,
      'embed-video': _vm.embedVideo
    }
  }, [_c('div', {
    staticClass: "rl-clearfix rl-wrap"
  }, _vm._l(_vm.list, function (item, index) {
    return index < 20 ? _c('div', {
      key: index,
      staticClass: "item",
      attrs: {
        "vid": item.vid
      }
    }, [[_c('div', {
      staticClass: "img",
      style: {
        backgroundImage: "url(".concat(_vm.turnHttps(item.videocapture), ")")
      }
    })], _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "back"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title || item.uname))])]), _vm._v(" "), _c('div', {
      staticClass: "hot"
    }, [_vm._v(_vm._s(item.heat))]), _vm._v(" "), _c('div', {
      staticClass: "mask",
      on: {
        "click": function click($event) {
          return _vm.onSkipLiveRoom(index);
        }
      }
    }, [_c('div', {
      staticClass: "play-text"
    }, [_vm._v(_vm._s(_vm.$t('home.playing')))]), _vm._v(" "), _c('div', {
      staticClass: "play-bg"
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 36 36"
      }
    }, [_c('path', {
      attrs: {
        "d": "M25.8 18c0 .6-.3 1.1-.8 1.3L12.5 27c-.2.1-.5.2-.8.2-.8 0-1.5-.6-1.5-1.5V10c0-.8.7-1.5 1.5-1.5.3 0 .5.1.8.2l12.7 7.9c.4.5.6.9.6 1.4z"
      }
    })])])])], 2) : _vm._e();
  }), 0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "icon-living"
  }, [_c('span', {
    staticClass: "icon-living-wave icon-living-wave-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-living-wave icon-living-wave-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-living-wave icon-living-wave-3"
  })]);
}];
export { render, staticRenderFns };